import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';
import { useContext, useState } from 'react';

import Input from '../../../../components/input/input';
import { SurfaceMarkingContext } from '../../../../providers/otc-trader/surface-marking-provider';
import { IListUserVolSurfacesBySymbolVols } from '../../../../providers/otc-trader/types';
import './styles.scss';

interface IVolatilitySurfaceConfirmModal {
  open: boolean;
  handleClose: () => void;
  dataVols: IListUserVolSurfacesBySymbolVols[];
}

export const VolatilitySurfaceConfirmModal = ({
  open,
  handleClose,
  dataVols,
}: IVolatilitySurfaceConfirmModal) => {
  const { createUserVolSurface, volatilityOptions } = useContext(SurfaceMarkingContext);
  const [inputTagValue, setInputTagValue] = useState('');

  const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setInputTagValue(inputValue);
  };

  const handleAddNewSurface = () => {
    const symbol = volatilityOptions.tokenPair;
    const source = volatilityOptions.spotSource;
    const tag = inputTagValue;
    const vols = dataVols;

    createUserVolSurface(symbol, source, tag, vols);
    setInputTagValue('');
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="volatility-surface-confirm-modal-container">
        <div className="volatility-surface-confirm-modal-content">
          <div className="volatility-surface-confirm-header">
            <h1>New surface</h1>

            <Button className="volatility-surface-confirm-close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>

          <Input
            placeholder="Create a name for this surface (optional)"
            value={inputTagValue}
            onChange={handleChangeValue}
            className="volatility-surface-confirm-modal-input"
          />
          <div className="volatility-surface-confirm-button-area">
            <Button
              className="volatility-surface-confirm-save-button"
              onClick={handleAddNewSurface}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
